import { render, staticRenderFns } from "./fee-lab-alocacao-pizzas.vue?vue&type=template&id=59382ad9&scoped=true&"
import script from "./fee-lab-alocacao-pizzas.vue?vue&type=script&lang=js&"
export * from "./fee-lab-alocacao-pizzas.vue?vue&type=script&lang=js&"
import style0 from "./fee-lab-alocacao-pizzas.vue?vue&type=style&index=0&id=59382ad9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59382ad9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59382ad9')) {
      api.createRecord('59382ad9', component.options)
    } else {
      api.reload('59382ad9', component.options)
    }
    module.hot.accept("./fee-lab-alocacao-pizzas.vue?vue&type=template&id=59382ad9&scoped=true&", function () {
      api.rerender('59382ad9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fee-fixo/components/fee-lab-alocacao-pizzas/fee-lab-alocacao-pizzas.vue"
export default component.exports